import styled, { css } from 'styled-components';
import {
    Flex,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';

import {
    Col,
} from '@zillow/zrs-comet';

export const StyledCol = styled(Col)`
    align-self: center;
`;

export const StyledFlex = styled(Flex)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: inherit;

    /* to handle long error messages */
    overflow: ${props => props.overflow};
`;

/* hide at the lg breakpoint */
export const StyledStatusContainer = styled.div`
    display: block;

    ${mediaMixin('lg_eq', css`
        display: none;
    `)}
`;

export const StyledCTAComponent = styled.div`
    display: none;

    ${mediaMixin('lg_eq', css`
        display: inline-block;
    `)}
`;

export const StyledBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: ${spaceMixin('md')};
    padding: ${spaceMixin('sm')};
    min-height: 200px;
    border-radius: 4px;
    border: solid 1px ${token('colors.gray200')};
    background-color: ${token('colors.white')};

    /* 769 */
    ${mediaMixin('lg', css`
        flex-direction: row;
    `)}

    /* 1025 */
    ${mediaMixin('xl', css`
        flex-direction: column;
    `)}
`;

/** **** hr **** **/
export const StyledHR = styled.div`
    flex-grow: 0;
    margin-bottom: 15px;
    border-bottom: 1px solid ${token('colors.gray200')};
    border-right: none;

    /* 769 */
    ${mediaMixin('lg', css`
        margin: 0 15px;
        border-bottom: none;
        border-right: 1px solid ${token('colors.gray200')};
    `)}

    /* 1025 */
    ${mediaMixin('xl', css`
        flex-grow: 0;
        margin-bottom: 15px;
        border-bottom: 1px solid ${token('colors.gray200')};
        border-right: none;
    `)}
`;
